<template>
	<div class="inform_tabel">
		<Table max-height='750' border ref="selection" :columns="columns" :data="noticeInfo"
			   @on-selection-change="selectionClick">
			<template slot-scope="{ row }" slot="noticeType">
				<span v-if="row.noticeType == '任务通知'" style="color: #318C27;">{{ row.noticeType }}</span>
				<span v-if="row.noticeType !== '任务通知'">{{ row.noticeType }}</span>
			</template>
			<template slot-scope="{ row }" slot="noticeContent">
				<span v-if="row.is_read == '0' " style="font-weight: bold;">{{row.noticeContent}}</span>
				<span v-if="row.is_read == '1' " style="">{{row.noticeContent}}</span>
			</template>
			<template slot-scope="{ row }" slot="operation">
				<span v-if="userInfo.menuList.homePage.teamNotice_removeNotice && type == '1'" @click="deleteNotice" :data-id="row.id" style="color: #54A1F3">删除</span>
				<span v-else-if="userInfo.menuList.homePage.teamNotice_removeTeamNotice && type == '2'" :data-id="row.id" @click="deleteNotice"  style="color: #54A1F3">删除</span>
				<span v-else-if="row.relateId && type == '4'" :data-id="row.relateId" @click="editCustomer"  style="color: #54A1F3">查看客户</span>
				<span v-else>--</span>
			</template>
		</Table>
		<div class="pager">
			<Page :total="count" :page-size="20" :current="page" @on-change="changePage" size="small" show-elevator />
		</div>
		<!--Button style="margin-top: 10px;" type="primary" @click="signToRead" size="small" slot="extra">标为已读</Button-->
		<!-- 编辑/新增客户 -->
		<div v-if="editClientDiv" style="background: #f9fafc;">
			<Modal v-model="editClientModal" width="95%" title="" footer-hide :styles="editModalStyle">
				<EditClue :id="clientId"  @beforeOne="beforeEditOne"  @nextOne="nextEditOne"></EditClue>
			</Modal>
		</div>
	</div>
</template>

<script>
	import {mapActions, mapGetters} from "vuex";
	import {
		getNoticeInfoByType,signNoticeToRead,deleteNotice
	} from '@/api/notice.js'
	import EditClue from "../client/EditClue";
	export default {
		name: "InformTabel",
		components: {EditClue},
		computed:{
			...mapGetters(['userInfo', 'token'])
		},
		props: ['type'],
		data() {
			return {
				editModalStyle: {'top': '7%', 'background': '#f9fafc', 'border-radius': '15px'},
				clientId: 0,
				editClientModal: false,
				editClientDiv: false,
				page: 1,
				count: 0,
				columns: [{
					type: 'selection',
					width: 60,
					align: 'center'
				},
					{
						title: '公告内容',
						// key: 'noticeContent',
						key:'noticeContent',
						width: 700,
						align: 'center'
					},
					{
						title: '时间',
						key: 'created_at',
						align: 'center'
					},
					{
						title: '类型',
						width: 100,
						align: 'center',
						slot:'noticeType',
						align: 'center'
					},
					{
						title: '发布人 ',
						width: 100,
						align: 'center',
						key: 'publisher'
					},
					{
						title: '操作',
						width: 100,
						align: 'center',
						slot:'operation',
						align: 'center'
					},
				],

				noticeInfo:[],
				selectNoticeInfo:[],
				isReadType:2 //0=>未读 1=>已读 2=>全部
			}
		},
		methods:{
			...mapActions([
				'getUserInfo',
			]),
			signToRead() {
				let that = this
				let data = {token:this.token, noticeInfo:this.selectNoticeInfo}
				if(that.selectNoticeInfo.length){
					signNoticeToRead(data).then(function(res){
						if(res.data.code == 1){
							that.$emit('getNotReadNoticeCount');
							that.getUserInfo();
							that.getNoticeInfoByType();
							that.$Message.success('标记成功');
						}else{
							that.$Message.warning('标记失败');
						}
					});
				}else{
					that.$Message.warning('请先选择');
				}
			},
			// 返回已选中的项
			selectionClick(e) {
				this.selectNoticeInfo = e;

			},
			//获取不同类型通知的内容 默认获取全部类型
			/*
            * type: 0 =>所有类型
            * isRead: 0=>未读 1=>已读 2=>全部
            */
			getNoticeInfoByType(){
				let that = this
				let data = {token: this.token, type: this.type, isReadType: that.isReadType, page: that.page}
				getNoticeInfoByType(data).then(function (res){
					that.noticeInfo = res.data.data
					that.count = res.data.count;
					//that.noticeInfo = res.data.data
				});
			},
			changePage(e) {
				this.page = e;
				this.getNoticeInfoByType();
			},
			deleteNotice(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				that.$Modal.confirm({
					title: '确认删除吗？',
					onOk: async() => {
						that.throttle(async function () {
							let data = {token: that.token, id: id}
							let res = await deleteNotice(that, data);
							if (res.code == 1) {
								that.$Message.success('删除成功');
								that.getNoticeInfoByType();
							}
						}, 1000);
					}
				})
			},
			editCustomer(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				this.clientId = id;
				this.editClientDiv = true;
				this.editClientModal = true;
			},
			beforeEditOne() {
				let that = this;
				that.$Message.error('此页面不可使用此功能');
			},
			nextEditOne() {
				let that = this;
				that.$Message.error('此页面不可使用此功能');
			}

		}
	}
</script>

<style scoped lang="less">


	/deep/ .ivu-modal-content{
		background-color: #f9fafc;
	}
</style>
